<template>
  <div>


    <van-nav-bar title="密码登录" fixed="fixed">
      <template #left>
        <div @click="$back(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <div style="padding-top: 46px;">
      <div style="padding-left: 24px;padding-right: 24px;padding-top: 80px">
        <van-form validate-first @failed="onFailed" :show-error="false">
          <!-- 通过 pattern 进行正则校验 -->
          <van-field
              v-model="phone"
              name="phone"
              placeholder="请输入手机号"
              :rules="[{ pattern, message: '请输入正确的手机号' }]"
              clearable


          />
          <van-field
              v-model="password"
              :type="showPassword?'textarea ':'password'"
              placeholder="请输入密码"
              :rules="[{ pattern:patternPW, message: '请输入6-20位数字+字母组成的密码' }]"
              clearable
          >
            <template #button>
              <div class="showPassword" @click="showPassword=!showPassword">
                <svg-icon :icon-class="showPassword?'openEyes':'closeEyes'"
                          :style="showPassword?'height:12px;width:19px':'height:16px;width:19px'"></svg-icon>
              </div>
            </template>
          </van-field>


          <div style="height: 40px"></div>


        </van-form>
      </div>
      <div style="padding-left: 40px;padding-right: 40px">


        <div class="loginButton" @click="login">登录</div>


        <div class="jump">
          <router-link to="/login" style="color: #585e6a">手机验证码登录</router-link>
          <router-link to="/forget" style="color: #585e6a">忘记密码</router-link>

        </div>


      </div>


    </div>


  </div>
</template>

<script>
export default {
  name: "password",
  data() {
    return {
      phone: '',
      password: '',
      pattern: /^[1][345789][0-9]{9}$/,
      patternPW: /^[A-Za-z0-9]{6,20}$/,
      showPassword: false,
    }
  },
  methods: {
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

    login() {
      let phoneCheck = this.phone.search(this.pattern)
      let passwordCheck = this.password.search(this.password)
      if (phoneCheck === 0 && passwordCheck === 0) {
        let query = this.$encrypt(this.$genQuery({
          mobile: this.phone,
          password: this.password,
        }))
        this.$post(this.$store.state.apiUrl + '/member/login', {qdata: query}).then(res => {
          console.log(res)

          if (res.status === 0) {
            this.$toast(res.msg);
            this.$setUserData(res)
            this.$store.state.SignedIn = true
            this.$router.push('/userCenter')


          } else {
            this.$toast(res.msg);
          }
        }).catch(err => {
          console.log(err)
        })

      } else {
        if (phoneCheck !== 0) {
          this.$toast('请输入正确的手机号');
        } else if (passwordCheck !== 0) {
          this.$toast('请输入6位及以上的密码');
        }


      }

    }
  }

}
</script>

<style scoped>


.jump {
  margin-top: 10px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
}
</style>
